import { useState } from "react";
import type { UserPermissionGroupsRemoveModalInterface } from "@dealer-center/ddc-pages-user-permissions-manager-interface";
import { RemoveUserFromGroupModal } from "../modals/remove-user-from-group";
import { AddUserToGroupModal } from "../modals/add-user-to-group";

export const usePermissionGroupModals = () => {
  const [modal, setModal] = useState<React.ReactElement>(<></>);
  const showRemoveUserFromGroupModal = (
    values: UserPermissionGroupsRemoveModalInterface
  ) => {
    setModal(
      <RemoveUserFromGroupModal
        close={() => setModal(<></>)}
        show={true}
        values={values}
      />
    );
  };

  const showAddUserToGroupModal = () => {
    setModal(<AddUserToGroupModal close={() => setModal(<></>)} show={true} />);
  };
  return {
    showRemoveUserFromGroupModal,
    showAddUserToGroupModal,
    modal
  };
};
